import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const VisionSection = ({ content }) => {
  if (!content) return null;

  return (
    <section id="vision" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {content.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-amber-500 mx-auto rounded-full" />
        </div>

        {/* Concept and Image */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-slate-900">
              {content.concept.title}
            </h3>
            <p className="text-lg text-slate-600 leading-relaxed">
              {content.concept.description}
            </p>
            <ul className="space-y-3">
              {content.concept.features.map((feature, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src={content.image}
              alt="Alcarias Hills Vision"
              className="w-full h-full object-cover aspect-[4/3]"
            />
          </div>
        </div>

        {/* Positioning and Fast Facts */}
        <div className="grid md:grid-cols-2 gap-12">
          {/* Positioning */}
          <div className="bg-gradient-to-br from-blue-50 to-slate-50 rounded-2xl p-8 border border-blue-100">
            <h3 className="text-2xl font-bold text-slate-900 mb-6">
              {content.positioning.title}
            </h3>
            <div className="space-y-4">
              <div>
                <p className="text-sm font-semibold text-blue-600 uppercase tracking-wide mb-1">
                  Target Market
                </p>
                <p className="text-slate-700">{content.positioning.target}</p>
              </div>
              <div>
                <p className="text-sm font-semibold text-blue-600 uppercase tracking-wide mb-1">
                  Unique Value
                </p>
                <p className="text-slate-700">{content.positioning.unique}</p>
              </div>
              <div>
                <p className="text-sm font-semibold text-blue-600 uppercase tracking-wide mb-1">
                  Market Segment
                </p>
                <p className="text-slate-700">{content.positioning.market}</p>
              </div>
            </div>
          </div>

          {/* Fast Facts */}
          <div className="bg-gradient-to-br from-amber-50 to-slate-50 rounded-2xl p-8 border border-amber-100">
            <h3 className="text-2xl font-bold text-slate-900 mb-6">
              {content.fastFacts.title}
            </h3>
            <div className="space-y-4">
              {content.fastFacts.facts.map((fact, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between pb-3 border-b border-slate-200 last:border-0"
                >
                  <span className="text-sm font-medium text-slate-600">
                    {fact.label}
                  </span>
                  <span className="text-base font-bold text-slate-900">
                    {fact.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
